/**
 * Fades and slides in each page section as a single unit when it scrolls into view.
 * Unlike the per-card reveal, this never animates the blocks inside a section separately.
 */
export const initializeSectionReveal = () => {
  const sections = document.querySelectorAll('[data-scroll-section]')
  if (!sections.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return

        const section = entry.target
        section.style.opacity = '1'
        section.style.transform = 'translateY(0)'

        // Drop the transform once settled so it stops acting as a containing
        // block for any fixed-position content nested inside the section.
        section.addEventListener('transitionend', () => {
          section.style.transform = ''
        }, { once: true })

        observer.unobserve(section)
      })
    },
    // threshold 0 + a shrunk bottom margin reveals the section as soon as its
    // top edge appears, rather than waiting for a large fraction of a
    // (possibly viewport-height-or-taller) section to be visible.
    { threshold: 0, rootMargin: '0px 0px -10% 0px' }
  )

  sections.forEach((section) => observer.observe(section))
}
